<template>
  <div class="about-us about-us-page">
    <div class="banner">
      <div class="title">上上签同业签证平台</div>
      <div class="banner-line"></div>
      <div class="banner-time">成立于2015</div>
    </div>
    <div class="about-us-introduce">
      <div class="about-us-introduce-left">
        <img class="about-us-introduce-title" src="../assets/imgs/common/header-logo-blue.png">
        <div class="about-us-introduce-content">
          上上签，深圳市六六六国际旅行社有限公司旗下品牌，专注于科技创新驱动的智能办签平台，荣膺多家OTA平台以及国内多家头部同业签证产品战略供应商。
        </div>
        <div class="about-us-introduce-content">作为业内领先的同业智能办签平台，上上签同业签证平台提供了签证办理全链条上各个环节的数字化解决方案，极大提升了产业链上各个职能的效率。同业在上上签可实现在线浏览签证资料和要求、在线下单、在线提交资料、手机拍照不跑照相馆、自动填写申请表、实时查看办签进度、系统自动处理签证，大大提升了客户沟通效率、资料准备效率、办签过程效率。</div>
        <div class="about-us-introduce-content">上上签同业签证平台涵盖100+国家、全国各领区、各签证类型产品，支持电脑端、小程序端在线查看与订单管理，并提供API、H5等多种方式，满足不同类型的同业需求。多年深耕供应链，上上签成功打造强大的供应链体系，结合行业领先的科技创新能力，致力于成为合作伙伴最值得信赖的签证解决方案提供商。</div>
        <div class="about-us-introduce-content">上上签创始团队由腾讯、微软、网易等知名互联网企业的成员组成，自2015年成立以来，上上签已完成四轮融资，融资总额超亿元。</div>
      </div>
      <img class="about-us-introduce-right" src="https://o.666visa.cn/static/ssqpeer/about-us/about-us-2.png">
      <div ></div>
    </div>
    <div class="honor">
      <div class="title">荣誉资质</div>
      <div class="content container-md">
        <div class="content-item" v-for="(item, index) in honorList" :key="index">
          <img class="icon" :src="item.icon" alt="">
          <div class="honor-content-title">{{item.title}}</div>
          <div class="desc-list">
            <div class="desc-item" v-for="(descItem, descIndex) in item.descList" :key="descIndex">{{descItem}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="timeline">
      <div class="title">发展历程</div>
      <div class="content">
        <div class="timeline-box">
          <div class="timeline-top container-md">
            <div class="timeline-item" v-for="(item,index) in currentTimeLine.topList" :key="index">
              <div class="timeline-item-time">{{ item.time }}</div>
              <div class="timeline-item-desc">{{ item.content }}</div>
            </div>
          </div>
          <div class="timeline-bottom container-md">
            <div class="timeline-item" v-for="(item,index) in currentTimeLine.bottomList" :key="index">
              <div class="timeline-item-time">{{ item.time }}</div>
              <div class="timeline-item-desc">{{ item.content }}</div>
            </div>
          </div>
          
          <div class="timeline-btn-left" v-if="timeLineInfo.timePage!==0" @click="changePage('pre')">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="timeline-btn-right" v-if="timeLineInfo.timePage!==currentTimeLine.length-1" @click="changePage('next')">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="enterprise-hope">
      <div class="title">企业愿景</div>
      <div class="content container-md">
        <div class="content-item">
          <div class="content-item-label">使命</div>
          <div class="content-item-desc">科技创新，提高签证行业效率</div>
        </div>
        <div class="content-item">
          <div class="content-item-label">愿景</div>
          <div class="content-item-desc">最值得信赖的签证解决方案提供商</div>
        </div>
        <div class="content-item">
          <div class="content-item-label">价值观</div>
          <div class="content-item-desc">客户至上，高效、专业、创新、进取</div>
        </div>
      </div>
    </div>
    <div class="join-us">
      <div class="title">加入我们</div>
      <div class="content container-md">
        <div class="content-item" v-for="(item, index) in jobList" :key="index" >
          <div class="job-title">{{item.title}}</div>
          <div class="job-field" v-for="fieldItem in item.fieldList" :key="fieldItem.label">
            <div class="label">{{fieldItem.label}}</div>
            <div class="desc-list">
              <div class="desc-item" v-for="descItem in fieldItem.descList" :key="descItem">{{descItem}}</div>
            </div>
            <div class="qrcode-box" v-if="fieldItem.qrcode">
              <img class="qrcode-img" :src="fieldItem.qrcode" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-us ">
      <div class="linear-gradient-box"></div>
      <div class="bg-box">
        <img src="../assets/imgs/homepage/contact-us-bg.png">
      </div>
      <div class="contact-body">
        <div class="title">联系我们</div>
        <div class="content container-md">
          <div class="list">
            <div class="content-item" v-for="(item, index) in contactList" :key="index">
              <div class="item-title">{{item.title}}</div>
              <div class="field-list">
                <div class="field-item" v-for="(fieldItem, fieldIndex) in item.fieldList" :key="fieldIndex">
                  <div class="field-item-label">{{fieldItem.label}}</div>
                  <div class="field-item-value">{{fieldItem.value}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <index-register v-if="!User.isLogin()"></index-register>
  </div>
</template>
<script>
import Honor1 from '../assets/imgs/homepage/honor1.png';
import Honor2 from '../assets/imgs/homepage/honor2.png';
import Honor3 from '../assets/imgs/homepage/honor3.png';
import indexRegister from './index/components/index-register';
import knowledgeService from '../services/knowledge-service';
import User from '../libs/user';

export default {
  name: '',
  components: {
    indexRegister,
  },
  data() {
    return {
      User,
      honorList: [
        {
          icon: Honor1,
          title: '企业荣誉',
          descList: [
            '深圳市专精特新中小企业',
            '国家级高新技术企业',
            '深圳市科技创新委员会2017年创业资助项目',
            '中国旅行社协会会员单位',
            '上海市旅游行业协会会奖商旅分会理事单位',
            '上海市会展行业协会会员单位',
          ],
        },
        {
          icon: Honor2,
          title: '产品荣誉',
          descList: [
            '荣获2024年旅业盛典年度最具影响力签证服务商大奖',
            '荣获2024年中国旅行社协会行业榜单创新经营企业案例',
            '荣获2023年ITB China旅游创业企业大奖金奖',
            '荣获2023年旅业签证业务合作创新奖',
            '荣获2021年第十届创新创业大赛成长组优秀企业',
          ],
        },
        {
          icon: Honor3,
          title: '知识产权',
          descList: [
            '9项发明专利',
            '101项软件著作权',
            '16项商标专利',
            '2项集成电路设计专有权',
          ],
        },
      ],
      jobList: [
        {
          title: '签证专家',
          fieldList: [
            {
              label: '工作地点：',
              descList: ['深圳'],
            },
            {
              label: '职位描述：',
              descList: [
                '1.对接客户签证咨询，快速提供专业解决方案，保持与客户的良好沟通；',
                '2.跟进名下签证订单，保障签证订单完结；',
                '3.维护名下客户，提高订单成交率。',
              ],
            },
            {
              label: '任职要求:',
              descList: [
                '1.良好的沟通能力和表达能力；',
                '2.熟悉签证工作流程优先；',
                '3.有过OTA平台对接客户签证需求、有内部签证系统操作经验者优先录取；',
                '4.有较强的服务意识和团队合作意识；',
                '5.为人正直诚信，责任心强，对工作有高度的责任心，有良好的抗压以及协调能力。',
              ],
            },
            {
              label: '简历投递：',
              descList: [
                'wenling.luo@idsuipai.com',
              ],
            },
          ],
        },
        {
          title: '商务BD',
          fieldList: [
            {
              label: '工作地点：',
              descList: ['广州、深圳、北京、上海、成都'],
            },
            {
              label: '职位描述：',
              descList: [
                '1.执行区域团队销售政策，制定个人销售计划和量化销售目标',
                '2.独立完成所负责区域内同业签证业务拓展工作',
                '3.对合作区域内KA旅业客户开展线下业务培训工作',
                '4.跟进名下旅业客户客情维护，推进签证业务合作成交率和留存率。',
              ],
            },
            {
              label: '任职要求：',
              descList: [
                '1.工作自驱力和目标感强，具体敏锐的市场业务洞察力和较强的沟通拓展能力',
                '2.为人正直诚信，对工作有高度的责任心，抗压以及协调能力、具备良好的团队精神',
                '3.两年及以上互联网To B行业销售工作经验，具备旅游同业出境销售经验者优先',
              ],
            },
            {
              label: '简历投递：',
              descList: [
                'wenling.luo@idsuipai.com',
              ],
            },
          ],
        },
      ],
      contactList: [
        {
          title: '深圳（总部）',
          fieldList: [
            {
              label: '联系人：',
              value: '高超',
            },
            {
              label: '电\xa0\xa0\xa0\xa0话：',
              value: '137 6036 3438',
            },
            {
              label: '邮\xa0\xa0\xa0\xa0箱：',
              value: 'gary.gao@idsuipai.com',
            },
            {
              label: '地\xa0\xa0\xa0\xa0址：',
              value: '深圳市南山区科兴科学园A1栋603',
            },
          ],
        },
        {
          title: '上海',
          fieldList: [
            {
              label: '联系人：',
              value: '王成',
            },
            {
              label: '电\xa0\xa0\xa0\xa0话：',
              value: '187 2110 0667',
            },
            {
              label: '邮\xa0\xa0\xa0\xa0箱：',
              value: 'cheng.wang@idsuipai.com',
            },
            {
              label: '地\xa0\xa0\xa0\xa0址：',
              value: '上海市长宁区天山西路568号统一企业广场A座8C02',
            },
          ],
        },
        {
          title: '广州',
          fieldList: [
            {
              label: '联系人：',
              value: '周泳均',
            },
            {
              label: '电\xa0\xa0\xa0\xa0话：',
              value: '158 9996 3281',
            },
            {
              label: '邮\xa0\xa0\xa0\xa0箱：',
              value: 'yongjun.zhou@idsuipai.com',
            },
            {
              label: '地\xa0\xa0\xa0\xa0址：',
              value: '广州市天河区黄埔大道西76号富力盈隆36楼他创空间3607',
            },
          ],
        },
        {
          title: '北京',
          fieldList: [
            {
              label: '联系人：',
              value: '王宇',
            },
            {
              label: '电\xa0\xa0\xa0\xa0话：',
              value: '177 2117 1416',
            },
            {
              label: '邮\xa0\xa0\xa0\xa0箱：',
              value: 'yu.wang@idsuipai.com',
            },
            {
              label: '地\xa0\xa0\xa0\xa0址：',
              value: '北京市朝阳区团结湖南里15号院恒祥大厦南厅6楼6019',
            },
          ],
        }, 
        {
          title: '成都',
          fieldList: [
            {
              label: '联系人：',
              value: '袁煜轩',
            },
            {
              label: '电\xa0\xa0\xa0\xa0话：',
              value: '183 0841 9800',
            },
            {
              label: '邮\xa0\xa0\xa0\xa0箱：',
              value: 'yuxuan.yuan@idsuipai.com',
            },
            {
              label: '地\xa0\xa0\xa0\xa0址：',
              value: '成都市锦江区下东大街段199号睿东中心 WeWork中国(睿东中心)',
            },
          ],
        },
      ],
      fistCompanyActivity: {},
      restActivityList: [],
      currentActivityPage: 0,
      perActivityPageCount: 3,
      totalPageCount: 0,
      showRightActivities: true,
      intervalTimer: null,
      pageCounter: 0,
      haveActivities: false,
      timer: null,
      timeLineInfo: {
        timePage: 0,
        list: [
          {
            topList: [
              {
                time: '2023.09',
                content: '上上签智能签证解决方案荣获ITB China旅游创业企业大奖金奖',
              },
              {
                time: '2022.12',
                content: '获得信息安全管理体系认证证书',
              },
              {
                time: '2021.11',
                content: '柬埔寨电子签直连上线',
              },
            ],
            bottomList: [
              {
                time: '2023.07',
                content: '2021.06  获得质量管理体系认证证书',
              },
              {
                time: '2022.04',
                content: '泰国落地签直连上线',
              },
              {
                time: '2019.10',
                content: '荣获“国家级高新技术企业“称号',
              },
            ],
          },
          {
            topList: [
              {
                time: '2018.08',
                content: '获得B轮融资，深圳博汇源投资领投，原创资本跟投',
              },
              {
                time: '2017.01',
                content: '上上签官网上线',
              },
              {
                time: '2016.01',
                content: '获得暴龙资本天使投资',
              },
            ],
            bottomList: [
              {
                time: '2017.03',
                content: '上上签小程序“办签助手”上线',
              },
              {
                time: '2016.12',
                content: '获得数千万人民币A轮融资，领投方为原创投资、福鱼资本和暴龙资本跟投',
              },
              {
                time: '2015.07',
                content: '公司成立，创始团队曾就职于腾讯/微软/网易等知名互联网企业',
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    currentRestActivityList() {
      if (this.restActivityList && this.restActivityList.length > 0) {
        return this.restActivityList.slice(
          this.currentActivityPage * this.perActivityPageCount,
          this.currentActivityPage * this.perActivityPageCount + this.perActivityPageCount,
        );
      }
      return [];
    },
    currentTimeLine() {
      return this.timeLineInfo.list[this.timeLineInfo.timePage];
    },
  },
  methods: {
    // 时间线按钮
    changePage(type) {
      if (type === 'pre') {
        if (this.timeLineInfo.timePage === 0) return;
        this.timeLineInfo.timePage--;
      }
      if (type === 'next') {
        if (this.timeLineInfo.timePage === this.timeLineInfo.list.length - 1) return;
        this.timeLineInfo.timePage++;
      }      
    },
    stopTimerAndGoToPage(page) {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
      }
      this.currentActivityPage = page;
    },
    restartTimer() {
      this.intervalTimer = null;
      setTimeout(() => {
        this.pageCounter = this.pageCounter + 1;
        this.changeActivityPageAuto(this.totalPageCount);
      }, 0);
    },
    changeActivityPageAuto(totalPageCount) {
      if (totalPageCount > 1) {
        this.intervalTimer = setInterval(() => {
          this.pageCounter = this.pageCounter + 1;
          this.currentActivityPage = (totalPageCount + this.pageCounter) % totalPageCount;
        }, 5000);
      }
    },
    loadCompanyActivities() {
      knowledgeService.visaArticleBriefQuery({
        catalog_id: 3,
      }).then((data) => {
        this.haveActivities = data && data.page_data && data.page_data.length > 0;
        this.fistCompanyActivity = data.page_data[0];
        this.restActivityList = data.page_data.slice(1);

        // 整页的有几页
        const pageCount = Math.floor(this.restActivityList.length / this.perActivityPageCount);

        // 剩余的最后一页不满的剩下几项
        const restPageItemCount = this.restActivityList.length % this.perActivityPageCount;

        // 总共有多少页
        const totalPageCount = pageCount + (restPageItemCount > 0 ? 1 : 0);
        this.totalPageCount = totalPageCount;
        this.changeActivityPageAuto(totalPageCount);
      }).catch((err) => {
        console.log(err);
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalTimer);
  },
  mounted() {
    if (this.$route.query.to === 'join') {
      const joinEl = document.querySelector('.join-us');
      setTimeout(() => {
        window.scrollTo(0, joinEl.offsetTop - 50);
      }, 100);
    }
  },
  created() {
    this.loadCompanyActivities();
  },
};
</script>
<style lang="less" scoped>
.about-us{
  background: #fff;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.banner{
  width: 100%;
  height: 547px;
  background:url(https://o.666visa.cn/static/ssqpeer/about-us/about-us-1.png) no-repeat center/cover;
  margin-top: -68px;
  padding-top: 168px;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    text-align: center;
    font-size: 56px;
    font-weight: 600;
    line-height:78px;
    letter-spacing:8px;
    margin-bottom: 20px;
  }
  .banner-line{
    width: 24px;
    height: 4px;
    background: #FFFFFF;
    margin-bottom: 20px;
  }
  .banner-time{
    font-size: 24px;
    line-height: 32rpx;
  }
}
.ssq-info{
  height: 360px;
  margin-top: -134px;
  position: relative;
  margin-bottom: 60px;
  &::after{
    content: "";
    position: absolute;
    width: 1036px;
    height: 222px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    background:linear-gradient(90deg,rgba(64,131,255,1) 0%,rgba(89,159,255,1) 100%);
    filter: blur(24px);
    z-index: 0;
  }
  .ssq-info-body{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background:linear-gradient(90deg,rgba(64,131,255,1) 0%,rgba(89,159,255,1) 100%);
    padding: 36px 40px 0px 60px;
    overflow: hidden;
    z-index: 1;
    &::after{
      content: 'About Us';
      position: absolute;
      left: -6px;
      bottom: -30px;
      line-height: 1;
      font-size: 100px;
      opacity:0.1;
      color: #fff;
    }
    &::before{
      content: '';
      position: absolute;
      right: -14px;
      bottom: -50px;
      background:url(../assets/imgs/homepage/info-right-bg.png) no-repeat center;
      background-size: 100% 100%;
      width: 350px;
      height: 350px;
      z-index: 1;
    }
  }


  .content{
    position: relative;
    z-index: 2;
    display: flex;
  }
  .logo{
    flex-shrink: 0;
    width: 224px;
    height: 60px;
    margin-right: 78px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .desc{
    flex-grow: 1;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    .desc-item{
      margin-bottom: 36px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.honor{
  padding: 48px 0;
  background: #FAFBFC;
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #2F333D;
    font-weight: 600;
    position: relative;
    margin-bottom: 48px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }
  .content{
    display: flex;
    background: #FAFBFC;
    .content-item{
      background: #fff;
      flex-grow: 1;
      width: 200px;
      margin-right: 40px;
      border-radius:4px;
      border:1px solid rgba(233,238,242,1);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      padding-bottom: 48px;
      &:nth-child(1){
        padding: 0 65px;
        padding-top: 50px;
      }
      &:nth-child(2){
        padding: 0 50px;
        padding-top: 50px;
        padding-bottom: 48px;
      }
      &:last-child{
        margin-right: 0;
      }
      .icon{
        width: 120px;
        height: 120px;
        margin-bottom: 24px;
      }
      .honor-content-title{
        font-size: 24px;
        color: #2F333D;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .desc-list{
        .desc-item{
          text-align: center;
          font-size: 16px;
          line-height: 22px;
          color: #91999F;
          margin-bottom: 16px;
        }
      }
    }
  }
}
.timeline{
  width: 100%;
  height: 520px;
  margin-bottom: 24px;
  padding-top: 48px;
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #2F333D;
    font-weight: 600;
    position: relative;
    margin-bottom: 80px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }
  .content{
    position: relative;
    &::after{
      content: "";
      position: absolute;
      top: 125px;
      left: 0;
      width: 100%;
      height: 1px;
      background:linear-gradient(270deg,rgba(201,205,209,0.1) 0%,rgba(201,205,209,1) 51%,rgba(201,205,209,0.1) 100%);
    }
    .timeline-top{
      position: relative;
      display: flex;
      .timeline-item{
        width: 20%;
        height: 125px;
        padding: 0 42px 0 16px;
        position: relative;
        &:nth-child(1){
          width: 310px;
        }
        &:nth-child(2){
          width: 310px;
        }
        &:nth-child(3){
          width: 350px;
        }
        &:nth-child(4){
          width: 200px;
        }
        &:nth-child(5){
          width: 160px;
        }
        .timeline-item-time{
          color: #599FFF;
          font-size: 32px;
          font-weight: 600;
          line-height: 40px;
          margin-bottom: 4px;
        }
        .timeline-item-desc{
          color: #5F666E;
          font-size: 14px;
          line-height: 20px;
        }
        &::after{
          content: "";
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 9px;
          height: 112px;
          background:url(../assets/imgs/homepage/line-top.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .timeline-bottom{
      padding-left: 130px;
      display: flex;
      .timeline-item{
        position: relative;
        width: 25%;
        height: 120px;
        padding: 55px 16px 0 16px;
        position: relative;
        &:nth-child(1){
          width: 316px;
        }
        &:nth-child(2){
          width: 335px;
        }
        &:nth-child(3){
          width: 230px;
        }
        &:nth-child(4){
          width: 260px;
        }
        .timeline-item-time{
          color: #599FFF;
          font-size: 32px;
          font-weight: 600;
          line-height: 40px;
          margin-bottom: 4px;
        }
        .timeline-item-desc{
          color: #5F666E;
          font-size: 14px;
          line-height: 20px;
        }
        &::after{
          content: '';
          position: absolute;
          left: 0;
          top: -2px;
          width: 9px;
          height: 81px;
          background:url(../assets/imgs/homepage/line-bottom.png) no-repeat;
          background-size: 100% 100%;
        }

      }
    }
  }
  .timeline-box{
    width: 1120px;
    margin: 0 auto;
    position: relative;
    padding-left: 80px;
  }
  .timeline-btn-left,.timeline-btn-right{
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    cursor: pointer;
    color: #599FFF;
    background-color: #fff;
    border: 2px solid #599FFF;
    &:hover{
      color: #fff;
      background: #599FFF;
    }
  }
  .timeline-btn-left{ 
    left: 0px;
  }
  .timeline-btn-right{
    
    right: 0px;
  }
}
.enterprise-hope{
  height: 440px;
  background:url(https://o.666visa.cn/static/ssqpeer/about-us/about-us-3.png) no-repeat center/cover;
  padding-top: 48px;
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #fff;
    font-weight: 600;
    position: relative;
    margin-bottom: 64px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }
  .content{
    display: flex;
    .content-item{
      width: 33.33%;
      background:linear-gradient(270deg,rgba(89,159,255,0.9) 0%,rgba(64,131,255,0.9) 100%);
      border-radius:2px;
      height:160px;
      text-align: center;
      color: #fff;
      padding-top: 24px;
      margin-right: 30px;
      position: relative;
      overflow: hidden;
      &:last-child{
        margin-right: 0;
      }
      &:nth-child(1){
        &::after{
          content: 'Mission';
          position: absolute;
          left: 50%;
          opacity: 0.08;
          bottom: -30px;
          transform: translateX(-50%);
          color: #FFFFFF;
          font-size:88px;
          font-weight: 600;
        }
      }
      &:nth-child(2){
        &::after{
          content: 'Vision';
          position: absolute;
          left: 50%;
          opacity: 0.08;
          bottom: -30px;
          transform: translateX(-50%);
          color: #FFFFFF;
          font-size:88px;
          font-weight: 600;
        }
      }
      &:nth-child(3){
        &::after{
          content: 'Values';
          position: absolute;
          left: 50%;
          opacity: 0.08;
          bottom: -30px;
          transform: translateX(-50%);
          color: #FFFFFF;
          font-size:88px;
          font-weight: 600;
        }
      }
      .content-item-label{
        font-size:28px;
        font-weight:600;
        line-height:40px;
        margin-bottom: 12px;
      }
      .content-item-desc{
        font-size:18px;
        line-height:32px;
      }
    }
  }
}
.company-activity {
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #2F333D;
    font-weight: 600;
    position: relative;
    margin-bottom: 51px;
    margin-top: 56px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }
  .content {
    display: flex;
    margin-bottom: 40px;
    .the-first-activity {
      display: flex;
      flex-direction: column;
      width: 500px;
      .top-img {
        width: 500px;
        height: 260px;
        background-color: gray;
      }
      .activity-title {
        margin-top: 16px;
        font-size: 20px;
        font-weight: 500;
        color: #2F333D;
        line-height: 28px;
      }
      .activity-desc {
        font-size: 16px;
        font-weight: 400;
        color: #5F666E;
        line-height: 26px;
        margin-top: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .activity-date {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #5F666E;
      }
    }
    .right-acticity-box {
      margin-left: 50px;
      display: flex;
      flex: 1;
      flex-direction: column;
      .activity-box {
        display: flex;
        flex-direction: column;
        flex: 1;
        .activity-item {
          padding: 8px 16px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          cursor: pointer;
          overflow: hidden;
          &:last-child {
            margin-bottom: 0;
          }
          &:hover{
            background-color: #F3F6F9;
            border-radius: 1px;
          }
          .left-date-month {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            border-right: 1px solid #E9EEF2;
            padding-right: 25px;
            width: 74px;
            height: 86px;
            flex-shrink: 0;
            .top-date {
              font-size: 24px;
              font-weight: 400;
              color: #5F666E;
              line-height: 24px;
            }
            .bottom-month {
              margin-top: 8px;
              font-size: 14px;
              font-weight: 400;
              color: #5F666E;
            }
          }
          .right-title-desc {
            display: flex;
            flex-direction: column;
            margin-left: 24px;
            overflow: hidden;
            .activity-title {
              font-size: 18px;
              font-weight: 600;
              color: #2F333D;
              line-height: 25px;
            }
            .activity-desc {
              font-size: 16px;
              font-weight: 400;
              color: #5F666E;
              line-height: 26px;
              height: 52px;
              margin-top: 9px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .page-navs {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 24px;
        .nav-item {
          width: 8px;
          height: 8px;
          background: #2F333D;
          opacity: 0.2;
          margin-right: 10px;
          border-radius: 100%;
          &.active {
            opacity: 0.8;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.join-us{
  padding: 48px 0;
  background: #FAFBFC;
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #2F333D;
    font-weight: 600;
    position: relative;
    margin-bottom: 48px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }

  .content{
    display: flex;
    position: relative;
    background: #FAFBFC;
    .content-item{
      background: #fff;
      padding: 36px 30px 80px 40px;
      border:1px solid rgba(233,238,242,1);
      width: 50%;
      margin-right: 40px;
      color: #2F333D;
      font-size: 16px;
      line-height: 22px;
      margin-right: 40px;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        top:-1px;
        left: 0;
        width: 100%;
        height: 4px;
        background:linear-gradient(270deg,rgba(118,174,255,1) 0%,rgba(47,132,255,1) 100%);
        border-radius:2px;
      }
      &::before{
        content: "";
        position: absolute;
        right: 20px;
        top: 20px;
        width: 76px;
        height: 70px;
        background:url(../assets/imgs/homepage/join-right.png) no-repeat center;
        background-size: 100% 100%;
      }
      &:last-child{
        margin-right: 0;
      }
      .job-title{
        font-weight: 600;
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 10px;
      }
      .job-field{
        margin-bottom: 20px;
        letter-spacing: 1px;
        .label{
          margin-bottom: 6px;
          color: #2F333D;
          font-weight: 600;
        }
        .desc-list{
          line-height: 20px;
          color: #5F666E;
          font-size: 14px;
        }
        .qrcode-box{
          .qrcode-img{
            width: 100px;
          }
        }

      }
    }
  }
}
.contact-us{
  position: relative;
  z-index: 1;
  .linear-gradient-box{
    width: 100%;
    height: 513px;
    background:linear-gradient(180deg,rgba(255,255,255,1) 12%,#fafafa 100%);
  }
  .bg-box{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .contact-body{
    padding: 48px 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
  }
  .title{
    text-align: center;
    font-size: 32px;
    line-height: 32px;
    color: #2F333D;
    font-weight: 600;
    position: relative;
    margin-bottom: 48px;
    z-index: 1;
    &::after{
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%);
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity: 0.8;
      z-index: -1;
    }
  }
  .content{
    .list{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -35px;
      margin-bottom: -42px;
    }
    .content-item{
      width: 33%;
      padding: 0 25px;
      margin-bottom: 42px;
      .item-title{
        color: #2F333D;
        font-size:24px;
        font-weight: 600;
        line-height:32px;
        margin-bottom: 8px;
      }
      .field-list{
        line-height: 22px;
        .field-item{
          font-size: 14px;
          color: #2F333D;
          display: flex;
          margin-bottom: 10px;
          .field-item-label{
            flex-shrink: 0;
          }
          .field-item-value{
            flex-grow: 1;
          }
        }
      }
    }
  }
}
.about-us-page{
  .about-us-introduce{
    width: 1120px;
    display: flex;
    padding: 120px 0 80px 0;
    background-color: #fff;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
  }
  .about-us-introduce-left{
    margin-right: 80px;
  }
  .about-us-introduce-title{
    width: 180px;
    margin-bottom: 48px;
  }
  .about-us-introduce-content{
    color: #2F333D;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 36px;
    &:last-child{
      margin-bottom: 0px;
    }
  }
  .about-us-introduce-right{
    width: 440px;
    height: 296px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/AboutUs.vue